<template>
  <el-row class="movie-list">
    <el-col :md="12">
      <el-scrollbar style="width: 100%; height: 80vh;">
        <el-card class="box-card">
          <el-timeline :reverse="false">
            <el-timeline-item
              v-for="(item, index) in blogArchive"
              :key="index"
              :timestamp="item.pubDate"
            >
              <router-link style="text-decoration-line: none" target="_blank" :to="`/blog/post/${item.articleId}`">
                {{ item.title }}
              </router-link>
            </el-timeline-item>
          </el-timeline>
        </el-card>
      </el-scrollbar>
    </el-col>
  </el-row>
</template>

<script>
import { getArchive } from '@/api/blog'

export default {
  name: 'ArchivePage',
  data() {
    return {
      blogArchive: []
    }
  },
  created() {
    document.title = '文章归档'
    this.getData()
  },
  methods: {
    getData() {
      getArchive().then(resp => {
        if (resp.code === 0) {
          this.blogArchive = resp.data
        } else {
          this.$message.error(resp.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    }
  }
}
</script>

<style scoped>
/*处于手机屏幕时*/
@media screen and (max-width: 768px) {
  .movie-list {
    padding: 5px;
  }
}

.movie-list {
  padding: 5px;
}
</style>
